import PicklistMetadata from "../PicklistMetadata";

class OrganizationTypePicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "OrganizationType";
        this.bounded = true;
        this.enterpriseComponent = "PickList Generic";
        this.longList = false;
        this.noDelete = true;
        this.noUpdate = true;
        this.noInsert = true;
        this.noMerge = true;
        this.searchSpecification = null;
        this.sortSpecification = null;
        this.static = true;
        this.typeField = "Type";
        this.typeValue = "OrganizationType";
        this.typeValue2 = null;
        this.visibilityType = null;
    }
}

export default OrganizationTypePicklistMetadata;
